import ActionTypes from "../constants/action_types";

export default function clearPrompts() {
  return {
    type: ActionTypes.PROMPTS_CLEAR.SUCCESS,
  };
}
